import React from 'react'
import {css} from '@emotion/react'
import Layout from '../../layout'
import {globalStylesProtection} from '../../../constants'

const LegalPageTemplate = ({data}) => {
    const {markdownRemark} = data
    const {html, frontmatter} = markdownRemark

    return (
        <Layout globalStyles={globalStylesProtection}>
            <div
                css={css`
                    width: 100%;
                    background: #000000;
                    min-height: 100vh;
                `}
            >
                <div
                    css={css`
                        max-width: 800px;
                        margin: 0 auto;
                        padding: 40px 20px;
                        overflow-x: auto;
                        -webkit-overflow-scrolling: touch;

                        h1 {
                            color: #f2f3fb;
                            font-size: 32px;
                            font-weight: 700;
                            margin-bottom: 24px;
                            text-align: center;
                        }

                        em {
                            color: #f2f3fb;
                        }

                        h2 {
                            color: #f2f3fb;
                            font-size: 24px;
                            font-weight: 600;
                            margin: 32px 0 16px 0;
                            border-bottom: 2px solid #333;
                            padding-bottom: 8px;
                        }

                        table {
                            width: 100%;
                            max-width: 100%;
                            table-layout: fixed;
                            border-collapse: collapse;
                            margin: 20px 0;
                            background: #000000;
                            border: 1px solid #333;
                            th,
                            td {
                                padding: 12px 16px;
                                text-align: left;
                                border-bottom: 1px solid #333;
                                color: #f2f3fb;
                                font-size: 14px;
                                line-height: 1.5;
                                word-break: break-word;
                                overflow-wrap: break-word;
                            }
                            th {
                                background: #111;
                                font-weight: 600;
                                border-bottom: 2px solid #333;
                            }
                            tr:nth-child(even) {
                                background: #0a0a0a;
                            }
                            tr:hover {
                                background: #1a1a1a;
                            }
                        }

                        h3 {
                            color: #f2f3fb;
                            font-size: 18px;
                            font-weight: 600;
                            margin: 24px 0 12px 0;
                        }

                        p {
                            color: #f2f3fb;
                            font-size: 16px;
                            line-height: 1.6;
                            margin-bottom: 16px;
                        }

                        strong {
                            font-weight: 600;
                            color: #f2f3fb;
                        }

                        a {
                            color: #e766ff;
                            text-decoration: underline;

                            &:hover {
                                color: #d555e6;
                            }
                        }

                        ul,
                        ol {
                            margin: 16px 0;
                            padding-left: 24px;

                            li {
                                color: #f2f3fb;
                                font-size: 16px;
                                line-height: 1.6;
                                margin-bottom: 8px;
                            }
                        }

                        /* Enhanced styling for ordered lists with letter numbering */
                        ol[style*='lower-alpha'] {
                            padding-left: 60px;
                            margin: 24px 0;

                            li {
                                margin-bottom: 20px;
                                padding: 16px 0;
                                position: relative;
                                line-height: 1.7;
                                padding-left: 20px;

                                &::marker {
                                    color: #f2f3fb;
                                    font-weight: 600;
                                    font-size: 18px;
                                }
                            }
                        }

                        @media (max-width: 768px) {
                            padding: 20px 16px;

                            h1 {
                                font-size: 28px;
                            }

                            h2 {
                                font-size: 20px;
                            }

                            p,
                            li {
                                font-size: 14px;
                            }

                            table th,
                            table td {
                                padding: 8px 10px;
                                font-size: 13px;
                            }

                            ol[style*='lower-alpha'] {
                                padding-left: 40px;

                                li {
                                    padding: 12px 0;
                                    margin-bottom: 16px;
                                    padding-left: 15px;
                                }
                            }
                        }
                    `}
                    dangerouslySetInnerHTML={{__html: html}}
                />
            </div>
        </Layout>
    )
}

export default LegalPageTemplate
